import { render, staticRenderFns } from "./purchase-returns.vue?vue&type=template&id=09e63a5d&scoped=true"
import script from "./purchase-returns.vue?vue&type=script&lang=js"
export * from "./purchase-returns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e63a5d",
  null
  
)

export default component.exports